import { useParams } from 'react-router-dom';
import { Room } from './Room';

export function RoomFactory() {
	const { code, tenant } = useParams();

	return (
		<Room code={code} tenant={tenant} />
	);
}
